var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import cx from 'classnames';
import styles from './PlusMinusIcon.module.scss';
export var PlusMinusIcon = function (_a) {
    var _b;
    var isOpen = _a.isOpen, className = _a.className, props = __rest(_a, ["isOpen", "className"]);
    var classNames = cx(styles.icon, (_b = {}, _b[styles.open] = isOpen, _b), className);
    return (React.createElement("div", __assign({ className: classNames, "data-testid": "plusMinus-icon" }, props),
        React.createElement("div", null),
        React.createElement("div", null)));
};
//# sourceMappingURL=PlusMinusIcon.js.map